export const CHECK_MERCHANT_OPERATION_SERVICE = "CHECK_MERCHANT_OPERATION_SERVICE";
export const GET_MERCHANTS_BASED_ON_CATEGORY = "GET_MERCHANTS_BASED_ON_CATEGORY";
export const GET_MERCHANTS_CATEGORIES = "GET_MERCHANTS_CATEGORIES";

export const GET_DELIVERY_MERCHANTS = "GET_DELIVERY_MERCHANTS";
export const GET_SELFPICKUP_MERCHANTS = "GET_SELFPICKUP_MERCHANTS";
export const GET_FAVORITE_MERCHANTS = "GET_FAVORITE_MERCHANTS";
